import { MapPin, Mail, Phone, Clock } from "lucide-react";
import LeadForm from "@/components/LeadForm";
import CalendlyEmbed from "@/components/CalendlyEmbed";

export default function Contact() {
  return (
    <div data-testid="page-contact">
      <section className="bg-white">
        <div className="sozos-container pt-12 md:pt-16 pb-16">
          <p className="eyebrow">Contact Us</p>
          <h1 className="font-display text-5xl sm:text-6xl lg:text-7xl text-[#0A1F44] mt-4 tracking-tight leading-[1.02] max-w-4xl">
            Let&apos;s talk revenue.
          </h1>
          <p className="text-lg md:text-xl text-slate-600 mt-7 max-w-3xl leading-relaxed">
            Tell us about your goals, your market, and where you&apos;re stuck. A senior strategist will
            respond within one business day.
          </p>
        </div>
      </section>

      <section className="bg-white">
        <div className="sozos-container pb-20">
          <div className="grid grid-cols-1 lg:grid-cols-12 gap-10">
            <div className="lg:col-span-5">
              <div className="bg-[#0A1F44] text-white rounded-md p-8 md:p-10">
                <p className="text-xs uppercase tracking-[0.22em] text-blue-300 font-semibold">Reach us</p>
                <h2 className="font-display text-3xl text-white mt-3 tracking-tight">Our offices & channels</h2>

                <div className="mt-8 space-y-6">
                  <ContactItem icon={Mail} label="Email" value="info@sozos.in" testid="contact-email" href="mailto:info@sozos.in" />
                  <ContactItem icon={Phone} label="Phone" value="+1 503-966-4577" testid="contact-phone" href="tel:+15039664577" />
                  <ContactItem icon={Phone} label="Toll free (US)" value="+1 (888) 688-5077" testid="contact-tollfree" href="tel:+18886885077" />
                  <ContactItem icon={MapPin} label="Offices" value="Coimbatore · Bengaluru, India" testid="contact-hq" />
                  <ContactItem icon={Clock} label="Hours" value="Mon – Fri · 24-hour global coverage" testid="contact-hours" />
                </div>

                <div className="mt-10 pt-8 border-t border-white/10">
                  <p className="text-xs uppercase tracking-[0.22em] text-blue-300 font-semibold">Press & partnerships</p>
                  <p className="text-sm text-slate-300 mt-2">info@sozos.in</p>
                </div>
              </div>
            </div>
            <div className="lg:col-span-7">
              <LeadForm source="contact-page" />
            </div>
          </div>
        </div>
      </section>

      <CalendlyEmbed />
    </div>
  );
}

function ContactItem({ icon: Icon, label, value, testid, href }) {
  const inner = (
    <div className="flex items-start gap-4">
      <div className="w-10 h-10 rounded-sm border border-white/20 flex items-center justify-center shrink-0">
        <Icon className="w-4 h-4 text-blue-300" />
      </div>
      <div>
        <div className="text-[10px] uppercase tracking-[0.22em] text-slate-400">{label}</div>
        <div className="text-sm text-white mt-1 leading-relaxed">{value}</div>
      </div>
    </div>
  );
  return href ? (
    <a data-testid={testid} href={href} className="block hover:opacity-90 transition">{inner}</a>
  ) : (
    <div data-testid={testid}>{inner}</div>
  );
}
